import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Receiving from "@/pages/Receiving";
import Processing from "@/pages/Processing";
import StockOnHand from "@/pages/StockOnHand";
import OffsiteStock from "@/pages/OffsiteStock";
import Orders from "@/pages/Orders";
import Dispatch from "@/pages/Dispatch";
import Shipments from "@/pages/Shipments";
import Damages from "@/pages/Damages";
import Finance from "@/pages/Finance";
import CostDashboard from "@/pages/CostDashboard";
import MasterData from "@/pages/MasterData";
import Documents from "@/pages/Documents";
import Audit from "@/pages/Audit";
import Reports from "@/pages/Reports";
import EmailCenter from "@/pages/EmailCenter";
import Settings from "@/pages/Settings";
import ChangePassword from "@/pages/ChangePassword";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster richColors position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/receiving" element={<ProtectedRoute><Receiving /></ProtectedRoute>} />
          <Route path="/processing" element={<ProtectedRoute><Processing /></ProtectedRoute>} />
          <Route path="/stock" element={<ProtectedRoute><StockOnHand /></ProtectedRoute>} />
          <Route path="/offsite" element={<ProtectedRoute><OffsiteStock /></ProtectedRoute>} />
          <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
          <Route path="/dispatch" element={<ProtectedRoute><Dispatch /></ProtectedRoute>} />
          <Route path="/shipments" element={<ProtectedRoute><Shipments /></ProtectedRoute>} />
          <Route path="/damages" element={<ProtectedRoute><Damages /></ProtectedRoute>} />
          <Route path="/finance" element={<ProtectedRoute><Finance /></ProtectedRoute>} />
          <Route path="/cost-dashboard" element={<ProtectedRoute><CostDashboard /></ProtectedRoute>} />
          <Route path="/master-data" element={<ProtectedRoute><MasterData /></ProtectedRoute>} />
          <Route path="/documents" element={<ProtectedRoute><Documents /></ProtectedRoute>} />
          <Route path="/audit" element={<ProtectedRoute><Audit /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
          <Route path="/email" element={<ProtectedRoute><EmailCenter /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
